import React, { FC, useEffect, useMemo, useState } from 'react';
import { ProgressSteps } from 'components/ProgressSteps/ProgressSteps';
import { useTranslation } from '@wix/wix-i18n-config';

const INTERVAL_TIME = 2 * 1000;

type Props = {
  shouldComplete: boolean;
  onComplete: () => void;
};

export const SiteSetupStepProgress: FC<Props> = ({ shouldComplete, onComplete }) => {
  const { t } = useTranslation();

  const [index, setIndex] = useState(0);

  const steps = useMemo(
    () => [
      t('site-setup-step.progress.item.title.1'),
      t('site-setup-step.progress.item.title.2'),
      t('site-setup-step.progress.item.title.3'),
      t('site-setup-step.progress.item.title.4'),
      t('site-setup-step.progress.item.title.5'),
    ],
    [t],
  );

  const itemsCount = steps.length;

  useEffect(() => {
    if (index >= itemsCount) {
      const timeoutId = setTimeout(onComplete, 1000);
      return () => clearTimeout(timeoutId);
    }
  }, [index, onComplete, itemsCount]);

  useEffect(() => {
    if (index >= itemsCount) {
      return;
    }

    const interval = setInterval(() => {
      setIndex((prev) => {
        return prev === itemsCount - 1 && !shouldComplete ? prev : prev + 1;
      });
    }, INTERVAL_TIME);

    return () => clearInterval(interval);
  }, [shouldComplete, index, itemsCount]);

  return <ProgressSteps currentStepIndex={index} steps={steps} />;
};
